import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { MomentModule } from 'angular2-moment';
import { MessageComponent } from 'src/pages/chat/components/message/message.component';
import { EmptyDataComponent } from './components/empty-data/empty-data.component';
import { AccordionComponent } from './components/expansion-panel/accordion/accordion.component';
import { ExpansionPanelComponent } from './components/expansion-panel/expansion-panel/expansion-panel.component';
import { RatingComponent } from './components/rating/rating.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SimpleItemComponent } from './components/simple-item/simple-item.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TabMenuComponent } from './components/tab-menu/tab-menu.component';
import { ColorLuminanceDirective } from './directives/color-luminance/color-luminance.directive';
import { CreditCardImageDirective } from './directives/credit-card/credit-card-image.directive';
import { ElasticDirective } from './directives/elastic/elastic.directive';
import { ImageLoaderDirective } from './directives/image-loader/image-loader';
import { FormFieldModule } from './form-field/form-field.module';
import { CustomCurrencyPipe } from './pipes/currency/custom-currency.pipe';
import { FormatPipe } from './pipes/format/format.pipe';
import { OrderByPipe } from './pipes/order-by/order-by.pipe';
import { SanitizePipe } from './pipes/santize/santize';
import { CommonService } from './services/common/common.service';
import { HttpErrorMessagesService } from './services/http-error-messages/http-error-messages.service';
import { FeedDetailComponent } from 'src/pages/feed/components/detail/detail.component';

@NgModule({
  declarations: [
    SpinnerComponent,
    ImageLoaderDirective,
    ElasticDirective,
    RatingComponent,
    SearchBarComponent,
    CustomCurrencyPipe,
    FormatPipe,
    OrderByPipe,
    EmptyDataComponent,
    SimpleItemComponent,
    AccordionComponent,
    ExpansionPanelComponent,
    CreditCardImageDirective,
    ColorLuminanceDirective,
    TabMenuComponent,
    MessageComponent,
    FeedDetailComponent,
    SanitizePipe
  ],
  entryComponents: [MessageComponent, FeedDetailComponent],
  exports: [
    SpinnerComponent,
    ImageLoaderDirective,
    ElasticDirective,
    RatingComponent,
    SearchBarComponent,
    CustomCurrencyPipe,
    FormatPipe,
    OrderByPipe,
    SimpleItemComponent,
    EmptyDataComponent,
    IonicModule,
    FormsModule,
    TranslateModule,
    FormFieldModule,
    MomentModule,
    CreditCardDirectivesModule,
    AccordionComponent,
    ExpansionPanelComponent,
    CreditCardImageDirective,
    TabMenuComponent,
    ColorLuminanceDirective,
    FeedDetailComponent,
    MessageComponent,
    SanitizePipe
  ],
  imports: [
    CommonModule,
    TranslateModule,
    IonicModule,
    FormsModule,
    FormFieldModule,
    MomentModule,
    CreditCardDirectivesModule
  ],
  providers: [
    CurrencyPipe,
    CustomCurrencyPipe,
    CommonService,
    HttpErrorMessagesService
  ]
})
export class AppCommonModule { }
